import { render, staticRenderFns } from "./DataStateMessage.vue?vue&type=template&id=424b09f1&scoped=true&"
import script from "./DataStateMessage.vue?vue&type=script&lang=js&"
export * from "./DataStateMessage.vue?vue&type=script&lang=js&"
import style0 from "./DataStateMessage.vue?vue&type=style&index=0&id=424b09f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424b09f1",
  null
  
)

export default component.exports